import { render, staticRenderFns } from "./Laboratory.vue?vue&type=template&id=82773118&scoped=true&"
import script from "./Laboratory.vue?vue&type=script&lang=js&"
export * from "./Laboratory.vue?vue&type=script&lang=js&"
import style0 from "./Laboratory.vue?vue&type=style&index=0&id=82773118&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82773118",
  null
  
)

component.options.__file = "Laboratory.vue"
export default component.exports